// extracted by mini-css-extract-plugin
module.exports = {"statsGridWrapper":"stats-grid_statsGridWrapper__XkVTC","statWrapper":"stats-grid_statWrapper__McMx2"};